import { render, staticRenderFns } from "./StatsPracticeHealth.vue?vue&type=template&id=210830d2&scoped=true&lang=html&"
import script from "./StatsPracticeHealth.vue?vue&type=script&lang=js&"
export * from "./StatsPracticeHealth.vue?vue&type=script&lang=js&"
import style0 from "./StatsPracticeHealth.vue?vue&type=style&index=0&id=210830d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210830d2",
  null
  
)

export default component.exports